export default [
  {
    path: 'gestao/notificacoes',
    name: 'notificacoes',
    component: () => import('./index'),
    children: [],
    meta: {
      visible: false,
      title: 'Notificações',
      breadcrumb: [
        { name: 'Home', link: 'home' },
        { name: 'Gestão', link: 'gestao' },
        { name: 'Notificações' }
      ]
    }
  },
]